import {
  redeemProsumerPartnerCodeRoute,
  type RedeemProsumerPartnerCodeResponse,
} from '@enki/contracts/prosumer/onboarding';
import { requestContract } from './contract-client';

export async function redeemPartnerCode(
  token: string,
  code: string
): Promise<RedeemProsumerPartnerCodeResponse> {
  return requestContract(redeemProsumerPartnerCodeRoute, {
    token,
    body: { code },
  });
}
